import { useEffect, useRef, useState } from 'react';
export const useSlotPresence = (active, closeMs)=>{
    const [rendered, setRendered] = useState(active);
    const [open, setOpen] = useState(false);
    const closeTimer = useRef(null);
    const openRaf = useRef(null);
    const closeMsRef = useRef(closeMs);
    closeMsRef.current = closeMs;
    useEffect(()=>{
        if (closeTimer.current != null) {
            clearTimeout(closeTimer.current);
            closeTimer.current = null;
        }
        if (openRaf.current != null) {
            cancelAnimationFrame(openRaf.current);
            openRaf.current = null;
        }
        if (active != null) {
            setRendered(active);
            openRaf.current = requestAnimationFrame(()=>setOpen(true));
        } else {
            setOpen(false);
            closeTimer.current = setTimeout(()=>setRendered(null), closeMsRef.current);
        }
        return ()=>{
            if (closeTimer.current != null) clearTimeout(closeTimer.current);
            if (openRaf.current != null) cancelAnimationFrame(openRaf.current);
        };
    }, [
        active
    ]);
    return {
        rendered,
        open
    };
};
